import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import PeacockDataTable from '@/components/organisms/PeacockDataTable';
import {useSimpleDataTable} from '@/hooks/useSimpleDataTable';
import {
  PRODUCT_GTIN_COLUMNS,
  toProductGtinRows
} from '@/utils/productGroupQuantity';
import './ProductGtinAssignmentTable.scss';

const PAGE_SIZE = 9;

const ProductGtinAssignmentTable = ({productGtins = []}) => {
  const rows = useMemo(() => toProductGtinRows(productGtins), [productGtins]);
  const {
    paginatedData,
    paginationConfig,
    selectionConfig,
    sortingConfig,
    filterConfig,
    toolbarConfig,
    displayConfig,
    pageSize
  } = useSimpleDataTable({
    data: rows,
    pageSize: PAGE_SIZE,
    noDataTitle: 'No products assigned'
  });

  return (
    <PeacockDataTable
      columns={PRODUCT_GTIN_COLUMNS}
      records={paginatedData}
      pageSize={pageSize}
      totalRecords={rows.length}
      paginationConfig={paginationConfig}
      selectionConfig={selectionConfig}
      sortingConfig={sortingConfig}
      filterConfig={filterConfig}
      toolbarConfig={toolbarConfig}
      displayConfig={{
        ...displayConfig,
        // Match the sales-target products table, which uses the default row
        // size. The compact size pads headers at 8px and rows at 4px.
        tableSize: 'large',
        wrapperClassName: 'product-gtin-assignment-table'
      }}
    />
  );
};

ProductGtinAssignmentTable.propTypes = {
  productGtins: PropTypes.arrayOf(
    PropTypes.shape({
      slot: PropTypes.number,
      gtin: PropTypes.string,
      productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      productName: PropTypes.string
    })
  )
};

export default React.memo(ProductGtinAssignmentTable);
